import React from "react";
import { version } from "../../../package.json";

export default class Image extends React.Component {
  render() {
    const { src, ...rest } = this.props;

    return <img {...rest} src={`${src}?v=${version}`} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/image.js